/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: 陈芳
 * @Date: 2022-08-22 16:03:36
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-10-09 10:57:12
 */
import RdColumnTypes from '@/utils/RdColumnTypes';
const talent_info = {
	key: 'talent_info',
	label: '达人信息',
	type: () => import('./components/tableCell/talentInfo'),
	minWidth: '265',
};
const fans_num = {
	key: 'fans_num',
	label: '粉丝量',
	type: 'rdText',
	minWidth: '90',
};

const fans_numSp = {
	key: 'fans_num',
	label: '粉丝数',
	type: 'rdText',
	minWidth: '150',
};
const liveCommerce = {
	key: 'liveCommerce',
	label: '直播带货数据',
	type: () => import('./components/tableCell/liveCommerce'),
	minWidth: '200',
	helpNum: 3,
	helpDesc1: '场均销售额：近30天带货直播场次的平均GMV，剔除开播时间小于25分钟的直播',
	helpDesc2: '直播观看人数：近30天卖货直播的观看人数的中位数',
	helpDesc3: '直播带货场次：近30天带货直播场次数量，剔除开播时间小于25分钟的直播',
};

const shortVideoCommerce = {
	key: 'shortVideoCommerce',
	label: '短视频带货数据',
	type: () => import('./components/tableCell/shortVideoCommerce'),
	minWidth: '200',
	helpNum: 2,
	helpDesc1: '带货短视频：近30天发布且挂商品链接的短视频数量',
	helpDesc2: '带货商品数：近30天短视频带货的商品种类',
};

const fee_30 = {
	key: 'fee_30',
	label: '30日销售额',
	type: 'rdText',
	minWidth: '140',
};

const fee_30Sp = {
	key: 'fee_30',
	label: '30日销售额',
	type: 'rdText',
	minWidth: '140',
};

const live_saleDy = {
	key: 'live_sale',
	label: '场均销售额',
	type: 'rdText',
	minWidth: '140',
};
const live_sale = {
	key: 'live_sale',
	label: '场均销售额',
	type: 'rdText',
	minWidth: '140',
};
const live_saleSp = {
	key: 'live_sale',
	label: '场均销售额',
	type: 'rdText',
	minWidth: '140',
};

const block_sale = {
	key: 'block_sale',
	label: '拉黑后销售额',
	type: 'rdText',
	minWidth: '150',
	helpNum: 1,
	helpDesc1: '从最近1次拉黑该达人次日开始计算产生的订单金额(包含退款订单)，数据t+1更新。',
};
const block_user_name = {
	key: 'block_user_name',
	label: '拉黑操作人',
	type: 'rdText',
	minWidth: '140',
};
const block_reason = {
	key: 'block_reason',
	label: '拉黑原因',
	type: 'rdText',
	ellipsisRow: 3,
	minWidth: '120',
};
const block_time = {
	key: 'block_time',
	label: '拉黑时间',
	type: 'rdText',
	minWidth: '140',
};

const operations = {
	key: 'operations',
	label: '操作',
	mode: 'vertical',
	type: RdColumnTypes.rdBtnGroup,
	minWidth: '80',
	fixed: 'right',
	align: 'right',
};

export const dyColumns = [talent_info, fans_num, liveCommerce, shortVideoCommerce, block_sale, block_user_name, block_reason, block_time, operations];
export const ksColumns = [talent_info, fans_num, fee_30, live_sale, block_sale, block_user_name, block_reason, block_time, operations];
export const spColumns = [talent_info, fans_numSp, fee_30Sp, live_saleSp, block_sale, block_user_name, block_reason, block_time, operations];
